module.exports = __webpack_public_path__ + "static/fonts/trebuchet_MS_Bold.f7ef644.ttf";